import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return <div className="text-center mt-5">Page Not Found</div>;
  }
}

export default NotFound;
